import * as React from "react";
import { forwardRef } from "react";
const SvgReceiver = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.96046e-07 2.12132L2.00117 2.11441L2.00117 5.77701L7.77818 0L9.19239 1.41421L3.41538 7.19122L7.07107 7.19813V9.19239H0L5.96046e-07 2.12132Z", fill: "#8C9EBA" }));
const ForwardRef = forwardRef(SvgReceiver);
export { ForwardRef as ReactComponent };
